import axios from "axios";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { ProjectViewModel } from "../../../../ViewModel/ProjectViewModel";
import { LtlPipelineViewModel } from "../../../../ViewModel/LtlPipelineViewModel";
import { LtlRoutingViewModel } from "../../../../ViewModel/LtlRoutingViewModel";
import { combinedUrls } from "../../../../../URL/functions";
import { projectUrls } from "../../../../../URL/ApplicationUrls";

function getFtlRouteIdAndNumbers(
  ftlRoutes: Array<FtlRouteViewModel>
): { number: string | undefined; id: number }[] {
  return ftlRoutes?.map((x) => {
    return {
      id: x.RouteId,
      number: x.RouteNumber,
    };
  });
}

export const getActiveLtlRouting = async (
  project: ProjectViewModel,
  ltlPipeline: LtlPipelineViewModel | undefined
) => {
  const ftlRouteIdAndNumbers = getFtlRouteIdAndNumbers(project?.FTLRoutes || []);

  const data = {
    SupplierGsdb: ltlPipeline?.SupplierGsdb,
    PlantGsdb: ltlPipeline?.PlantGsdb,
    DockCode: ltlPipeline?.DockCode,
    ContainerNetwork: ltlPipeline?.ContainerNetwork ?? null,
    FtlRouteIdAndNumbers: ftlRouteIdAndNumbers,
  };

  const url = combinedUrls(
    projectUrls.projectWithId(project.ProjectId).apiUrl,
    "/ActiveLtlRouting"
  );
  const response = await axios.post(url, data);
  return response.data as Array<LtlRoutingViewModel>;
};
